/* 
	在下方导入弹窗文件
	import xxx from 'xxx.vue'
	
	在DIALOG数组中注册组件
	DIALOG = [
		xxx
	]
	
	任意页面调用弹窗
	this.globalDialog(name, opt, resolve, cancel)
	可传入以下参数
	name: 弹窗name，对应弹窗文件中的name属性
	opt: {  传入弹窗的数据，包含两部分
		props: {...},  弹窗内props属性定义的变量值
		data: {...}  传入弹窗内open方法的数据
	}
	resolve:  确认回调函数，在弹窗内调用this.$emit('resolve')触发
	cancel: 取消回调函数，在弹窗内调用this.$emit('cancel')触发
	
	
	例如：
	this.globalDialog('staffSelector', {
		props: {
			multiple: true
		},
		data: {
			id: 1
		}
	}, this.aaa, this.bbb)
	
	等价于
	
	<staff-selector ref="staffSelector" :multiple="true" @resolve="aaa" @cancel="bbb"></staff-selector>
	this.$refs.staffSelector.open({
		id: 1
	});
 */

import router from '@/router';
import store from '@/store';

// 编辑系统用户
import sysuserEdit from '@/pages/system/sysuser_edit.vue'
// 编辑部门
import departmentEdit from '@/pages/system/department_edit.vue'
//编辑采购供应商弹窗
import purchaseSupplierEdit from '@/pages/purchase/purchase_supplier_edit.vue';
//采购单详情
import purchaseDetail from '@/pages/purchase/purchase_detail.vue';
//采购账单详情
import purchaseBillDetail from '@/pages/finance/purchase_bill_detail.vue';
//线下-采购单编辑
import offlinePurchaseEdit from '@/pages/purchase/offline_purchase_edit.vue';
//线上-采购单编辑
import onlinePurchaseEdit from '@/pages/purchase/online_purchase_edit.vue';
//采购退货详情、退货信息编辑、确认退货
import purchaseReturnDetail from '@/pages/purchase/purchase_return_detail.vue';
import purchaseReturnEdit from '@/pages/purchase/purchase_return_edit.vue';
import purchaseReturnConfirm from '@/pages/purchase/purchase_return_confirm.vue';

//库存盘点-创建/编辑
import inventoryEdit from '@/pages/storage/inventory_edit.vue';
//库存盘点-详情
import inventoryDetail from '@/pages/storage/inventory_detail.vue';
//商户提现单-详情
import saasWithdrawApplyDetail from '@/pages/finance/saas_withdraw_apply_detail.vue';
//提现单-详情
import withdrawApplyDetail from '@/pages/finance/withdraw_apply_detail.vue';

//财务-saas商户提现
import accountWithdraw from '@/pages/finance/account_withdraw.vue';
//财务-saas商户积分、保证金充值
import pointsRecharge from '@/pages/finance/points_recharge.vue';
//财务-saas商户充值
import accountRecharge from '@/pages/finance/account_recharge.vue';
// 批量编辑
import workFieldEdit from '@/components/view/work_field_edit.vue'
// 公式编辑器
import formulaEditor from "@/pages/custom/formula_edit.vue"
// 选择打印模板
import exportTemplateSelector from "@/components/service/export_template_selector.vue"
// 分享
import shareDialog from '@/components/service/share_dialog.vue'
// 系统业务日志
import workLogDetail from "@/pages/system/sys_work_logs_detail.vue"
// 导入Excel数据弹窗
import excelImport from "@/pages/system/import_excel_data.vue"
// 导入Excel数据弹窗（仅解析数据，不入库）
import excelImportAnalysis from "@/pages/system/import_excel_analysis.vue"
// 导入业务日志
import importLogDetail from "@/pages/system/import_work_logs_detail.vue"
// 模板管理
import templateManage from '@/components/service/template_manage.vue'
// 打印模板编辑
import printTemplateEdit from '@/components/service/print_template_edit.vue'
// 手机端视图配置
import appViewConfig from '@/components/service/app_view_config.vue'
// 用户视图字段配置
import fieldConfig from '@/components/view/user_field_config.vue'
//配置用户自定义【不良品项】信息
import defectsConfig from '@/components/service/defects_config.vue'
//配置用户自定义【指标】信息
import indeicatorFieldConfig from '@/components/service/indeicator_field_config.vue'
//核销确认单详情
import orderCheckDetail from "@/pages/finance/order_check_detail.vue";
//商户-提现申请记录列表
import withdrawApplyList from "@/pages/finance/withdraw_apply_list.vue";
//商户-充值申请记录列表
import rechargeApplyList from "@/pages/finance/recharge_apply_list.vue";
//三方同售账户提现申请
import cashWithdrawApply from "@/pages/finance/cash_withdraw_apply.vue";
//三方同售账户提现申请确认页面
import cashWithdrawApplyConfirm from "@/pages/finance/cash_withdraw_apply_confirm.vue";
//背贴码详情
import produceUniqueCodeDetail from "@/pages/product/produce_unique_code_detail.vue";
//资金账户收支记录列表
import accountRecordList from "@/pages/finance/account_record_list.vue";

//编辑客户弹窗
import customerEdit from "@/pages/basic/customer_edit.vue";
// 不良品
import defectsEdit from '@/pages/basic/dic_defects_edit.vue';
// 通用接驳弹窗（支持质检/维修/销售类型，接驳/驳回模式）
import handoverDialog from '@/components/service/handover_dialog.vue';
// 质检报告-扫码添加
import qualityReportScan from '@/pages/quality/quality_report_scan.vue';
// 质检-上传产品图片
import qualityUploadImage from '@/pages/quality/quality_upload_image.vue';
// 质检-修改商品串号
import qualityUpdateImei from '@/pages/quality/update_imei_dialog.vue';
// 质检报告详情
import qualityReportView from  '@/pages/quality/quality_report_view.vue';
// 质检报告未发布明细（图片未上传等原因）
import qualityPublishResult from '@/pages/quality/publish_result_dialog.vue';
// 维修记录弹框
import repairRecordDialog from '@/pages/repair/repair_record_dialog.vue';
// 送修弹框
import repairDeliveryDialog from '@/pages/repair/repair_delivery_dialog.vue';
// 新建维修记录弹框
import repairAddDialog from '@/pages/repair/repair_add_dialog.vue';
// 送修完成弹框
import repairCompleteDialog from '@/pages/repair/repair_complete_dialog.vue';
// 维修记录详情弹框（已冻结记录的只读查看入口）
import repairRecordDetailDialog from '@/pages/repair/repair_record_detail_dialog.vue';
// 送修记录详情弹框（已冻结记录的只读查看入口）
import repairDeliveryDetailDialog from '@/pages/repair/repair_delivery_detail_dialog.vue';
// 销售-选择上架渠道
import saleShelfChannel from '@/pages/sales/shelf_channel_dialog.vue';
// 销售-选择下架渠道（单个/批量）
import saleOffShelfChannel from '@/pages/sales/off_shelf_channel_dialog.vue';
// 销售-批量上架（仅对已发布渠道切上架状态，不发布不改价）
import saleBatchShelfChannel from '@/pages/sales/batch_shelf_channel_dialog.vue';
// 销售-批量上架未上架明细列表
import saleBatchShelfResult from '@/pages/sales/batch_shelf_result_dialog.vue';
// 销售-控价提醒结果（上架/改价破价已放行时的只读明细）
import salePriceWarnResult from '@/pages/sales/price_warn_result_dialog.vue';
// 销售-改价（同SKU/统一金额）
import salePriceEdit from '@/pages/sales/price_edit_dialog.vue';
// 销售-设置控价比例
import salePriceRatio from '@/pages/sales/price_ratio_dialog.vue';
// 销售-改价记录
import salePriceLog from '@/pages/sales/price_log_dialog.vue';
// 销售-推送记录
import salePushLog from '@/pages/sales/push_log_dialog.vue';
// 销售-商品列表推送记录（多展示推送类型列，仅商品列表使用）
import saleProductPushLog from '@/pages/sales/product_push_log_dialog.vue';
// 销售-借出记录
import saleLendLog from '@/pages/sales/lend_log_dialog.vue';
// 销售-新建借出
import saleLendEdit from '@/pages/sales/lend_edit_dialog.vue';
// 销售-批量归还
import saleLendReturn from '@/pages/sales/lend_return_dialog.vue';
// 销售客户编辑弹窗
import saleCustomerEdit from '@/pages/system/sale_customer_edit.vue';
// 销售订单详情抽屉（线上/线下）
import saleOrderDetail from '@/pages/sales/order_detail.vue';
// 线下售出订单新建/编辑
import offlineOrderEdit from '@/pages/sales/offline_order_edit.vue';
// 线下订单收款
import salePayDialog from '@/pages/sales/order_pay_dialog.vue';
// 线下订单发货
import offlineShipDialog from '@/pages/sales/offline_ship_dialog.vue';
// 线下订单批量发货
import offlineBatchShipDialog from '@/pages/sales/offline_batch_ship_dialog.vue';
// 申请售后
import offlineAftersaleApply from '@/pages/sales/offline_aftersale_apply.vue';
// 售后单详情
import offlineAftersaleDetail from '@/pages/sales/offline_aftersale_detail.vue';
// 售后单详情
import onlineAftersaleDetail from '@/pages/sales/online_aftersale_detail.vue';
// 登记退货物流
import saleReturnExpress from '@/pages/sales/order_return_express.vue';
// 超卖详情/处理
import oversoldDetail from '@/pages/sales/oversold_detail.vue';
// 销售-单条发货
import saleShipDialog from '@/pages/sales/ship_dialog.vue';
// 销售-批量发货
import batchShipDialog from '@/pages/sales/batch_ship_dialog.vue';
// 预收预付-新增预收/预付款弹窗
import advanceAddDialog from '@/pages/finance/advance_add_dialog.vue';
// 预收预付-核销处理弹窗
import advanceWriteOffDialog from '@/pages/finance/advance_write_off_dialog.vue';
// 线下采购单-IMEI出厂信息查询弹窗
import imeiFactoryQueryDialog from '@/pages/purchase/imei_factory_query_dialog.vue';
// 授信还款单详情
import creditRepaymentDetail from '@/pages/finance/credit_repayment_detail.vue';
// 授信账单还款审批记录
import creditRepaymentLog from '@/pages/finance/credit_repayment_log_dialog.vue';
// 授信还款单-通联扫码付款弹窗
import creditRepaymentPay from '@/pages/finance/credit_repayment_pay.vue';

import articleDetail from '@/pages/content/article_detail.vue';

const DIALOG = [
	sysuserEdit,
	departmentEdit,
	purchaseSupplierEdit,
	purchaseDetail,
	offlinePurchaseEdit,
	onlinePurchaseEdit,
	purchaseReturnDetail,
	purchaseReturnEdit,
	purchaseReturnConfirm,

	inventoryEdit,
	inventoryDetail,
	saasWithdrawApplyDetail,
	withdrawApplyDetail,

	accountRecharge,
	accountWithdraw,
	pointsRecharge,
	produceUniqueCodeDetail,

	workFieldEdit,
	formulaEditor,
	exportTemplateSelector,
	shareDialog,
	workLogDetail,
	excelImport,
	excelImportAnalysis,
	importLogDetail,
	templateManage,
	printTemplateEdit,
	appViewConfig,
	fieldConfig,
	defectsConfig,
	indeicatorFieldConfig,
	orderCheckDetail,
	withdrawApplyList,
	rechargeApplyList,
	cashWithdrawApply,
	cashWithdrawApplyConfirm,
	customerEdit,
	defectsEdit,
	handoverDialog,
	qualityReportScan,
	qualityUploadImage,
	qualityUpdateImei,
	qualityReportView,
	qualityPublishResult,
	repairRecordDialog,
	repairDeliveryDialog,
	repairAddDialog,
	repairCompleteDialog,
	repairRecordDetailDialog,
	repairDeliveryDetailDialog,
	saleShelfChannel,
	saleOffShelfChannel,
	saleBatchShelfChannel,
	saleBatchShelfResult,
	salePriceWarnResult,
	salePriceEdit,
	salePriceRatio,
	salePriceLog,
	salePushLog,
	saleProductPushLog,
	saleLendLog,
	saleLendEdit,
	saleLendReturn,
	saleCustomerEdit,
	saleOrderDetail,
	offlineOrderEdit,
	salePayDialog,
	offlineShipDialog,
	offlineBatchShipDialog,
	offlineAftersaleApply,
	offlineAftersaleDetail,
	onlineAftersaleDetail,
	saleReturnExpress,
	oversoldDetail,
	saleShipDialog,
	batchShipDialog,
	advanceAddDialog,
	advanceWriteOffDialog,
	imeiFactoryQueryDialog,
	purchaseBillDetail,
	accountRecordList,
	creditRepaymentDetail,
	creditRepaymentLog,
	creditRepaymentPay,
	articleDetail
]
const DIALOG_CACHE = {};
let zIndex = 1011;

export default {
	install: function(Vue) {
		function compareObjects(obj1, obj2) {
			const keys1 = Object.keys(obj1);
			const keys2 = Object.keys(obj2);

			if (keys1.length !== keys2.length) {
				return false;
			}

			for (let key of keys1) {
				if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
					return false;
				}
			}
			return true;
		}
		
		Vue.prototype.globalDialog = function(name, opt = {}, resolve, cancel) {
			if (typeof opt == 'function') {
				cancel = resolve;
				resolve = opt;
				opt = {};
			}
			
			if (DIALOG_CACHE[name] && !compareObjects(opt.props || {}, DIALOG_CACHE[name].props || {})) {
				DIALOG_CACHE[name].vm.$destroy();
			}
			
			if (!DIALOG_CACHE[name]) {
				DIALOG_CACHE[name] = {props: opt.props};
				let comp = DIALOG.find(comp => comp.name == name);
				if (!comp) return;
				let constructor = Vue.extend(comp);
				DIALOG_CACHE[name].vm = new constructor({
					router,
					store,
					el: document.createElement('div'),
					propsData: opt.props,
					beforeDestroy() {
						delete DIALOG_CACHE[name];
						this.$el.remove();
					}
				});
				document.body.appendChild(DIALOG_CACHE[name].vm.$el);
				DIALOG_CACHE[name].vm.$el.style.position = 'relative';
			}
			
			DIALOG_CACHE[name].vm.$el.style.zIndex = zIndex++;
			DIALOG_CACHE[name].vm.open(opt.data);
			
			let events = {resolve, cancel};
			for (let event in events) {
				DIALOG_CACHE[name].vm.$off(event);
				events[event] && DIALOG_CACHE[name].vm.$on(event, (...params) => {
					events[event].apply(this, params);
				});
			}

			return DIALOG_CACHE[name].vm;
		}

		Vue.prototype.globalDialogDestroy = function() {
			for (let name in DIALOG_CACHE) {
				DIALOG_CACHE[name].vm.$destroy();
			}
		}
	}
}
